export interface ILanguageCodes {
  [key: string]: number;
}

const languageCodes: ILanguageCodes = {
  'ru-ru': 1049,
  'en-US': 2057,
  'pt-PT': 1046,
  'fr-fr': 1036,
  'es-es': 3082,
};

export { languageCodes };
